<template>
  <div class="ios-pay">
    <w-dialog :dialog-show="state" @handleClose="handleClose">
      <div slot="content" class="content flex-column-center" @touchmove.prevent>
        <img :src="imgSrc" alt="">
        <p class="title">前往微信支付</p>
        <p class="message">电脑登录 <span class="high-light">wondercv.com</span><br />使用更多功能
        </p>
        <ul class="description">
          <li v-for="(item, index) in descriptionInfo" :key="index">{{ item }}</li>
        </ul>
        <button class="theme-button flex-center">
          <span class="iconfont iconweixin1"></span>
          <span @click="shareWx">发送至微信打开</span>
        </button>
        <p v-if="dialogType !== 'mentor'" class="pay-footer" @click="toUdesk">咨询客服</p>
      </div>
    </w-dialog>
  </div>
</template>

<script>
import WDialog from '@/components/global/w-dialog'
import { setupWebViewJavascriptBridge } from '@/assets/js/utils'
import { envMixin } from '@/assets/js/mixin/global'

export default {
  name: 'pay-dialog',
  mixins: [ envMixin ],
  props: {
    state: {
      type: Boolean,
      default: false
    },
    imgSrc: {
      type: String,
      default: 'https://files.wondercv.com/mobile/orders/ios-dialog.png'
    },
    descriptionInfo: {
      type: Array,
      default: () => [
        '来自顶级名企的专业导师',
        '投行咨询、BAT大厂、五百强',
        '中英文简历 1 对 1 反馈辅导',
        '帮你大幅提升求职成功率'
      ]
    },
    dialogType: {
      type: String,
      default: 'mentor'
    }
  },
  data () {
    return {}
  },
  mounted () {
  },
  computed: {},
  watch: {},
  components: {
    WDialog
  },
  methods: {
    handleClose () {
      this.$emit('handleClose')
    },
    // handleClick () {
    // 	this.$emit('handleClick')
    // },
    async toUdesk () {
      let res = await this.$api.user.getUdeskOnlineUrl()
      if (this.iosOrAndroid) {
        setupWebViewJavascriptBridge((bridge) => {
          bridge.callHandler('toCustomService',
            { url: res.data.udesk_online_url },
            function responseCallback (responseData) {
            })
        })
      }
    },
    shareWx () {
      this.$emit('shareWx')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/global/variable';
.ios-pay {
  .content {
    width: 80vw;
    padding: 0 22px 24px;
    border-radius: 8px;
    background-color: $color-light;
    img {
      width: 88px;
      height: 88px;
      border-radius: 50%;
      margin-top: -28px;
      margin-bottom: 16px;
    }
    .title {
      color: $color-title;
      font-size: $font-size-large-x;
      font-weight: 500;
      margin-bottom: 10px;
    }
    .message {
      color: $color-title;
      font-weight: 400;
      text-align: center;
      line-height: 20px;
      margin-bottom: 14px;
      .high-light {
        color: #027aff;
      }
    }
    .description {
      width: 100%;
      box-sizing: border-box;
      padding: 16px 18px 16px 30px;
      background-color: #fff7f7;
      border-radius: 8px;
      color: $color-dark-gray;
      margin-bottom: 24px;
      li {
        line-height: 24px;
        list-style-position: inside;
      }
    }
    button {
      width: 200px;
      height: 38px;
      border-radius: 21px;
      margin-bottom: 16px;
      span {
        font-weight: 400;
        font-size: $font-size-medium;
      }
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }
    .pay-footer {
      font-size: 13px;
      color: #9c9c9c;
      font-weight: 400;
    }
  }
}
</style>
